import actions from './constants';

export const showWorkflows = (category, results) => ({
  type: actions.SHOW_WORKFLOWS,
  category,
  results,
});

export const showWorkflowsError = (category, error) => ({
  type: actions.SHOW_WORKFLOWS_ERROR,
  category,
  error,
});

export const fetchWorkflow = (category, code) => ({
  type: actions.FETCH_WORKFLOW,
  category,
  code,
});

export const showWorkflow = (category, code, result) => ({
  type: actions.SHOW_WORKFLOW,
  category,
  code,
  result,
});

export const showWorkflowError = (category, code, error) => ({
  type: actions.SHOW_WORKFLOW_ERROR,
  category,
  code,
  error,
});

export const closeWorkflows = (category) => ({
  type: actions.CLOSE_WORKFLOWS,
  category,
});

export const closeWorkflow = (category, code) => ({
  type: actions.CLOSE_WORKFLOW,
  category,
  code,
});
